import { ContentCard, ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { Container, Grid, GridItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getSortedActionLogItemsByEntityOrOwnerId } from '@mews-commander/legacy-entities/src/ducks/actionLogItems';
import { getOrderItem } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector } from '@mews-commander/utils';
import { OrderItemName } from '../../../billing/components';
import ActionLogItemList from '../ActionLogItemList';
import ActionLogName from '../ActionLogName';
import ModalHeader from '../../../../legacy/React/Components/Common/ModalHeader';
import { useCloseButton } from '../../../../core/windowManager/hooks';
import OrderItemDetail from './OrderItemDetail';

interface OrderItemActionLogPageProps {
    orderItemId: string;
}

const OrderItemActionLogPage = ({ orderItemId }: OrderItemActionLogPageProps) => {
    const closeButton = useCloseButton();

    const orderItem = useCommanderSelector((state) => getOrderItem(state, { id: orderItemId }));

    const actionLogItems = useCommanderSelector((state) =>
        getSortedActionLogItemsByEntityOrOwnerId(state, { entityId: orderItemId })
    );

    if (!orderItem) {
        return null;
    }

    return (
        <ModalWrapper>
            <ModalHeader
                primaryAction={closeButton}
                title={<ActionLogName title={<OrderItemName orderItem={orderItem} />} />}
            />
            <ModalBodyWrapper padded>
                <Container padding="100">
                    <Grid templateColumns="0.35fr 0.65fr" largePhoneMax={{ templateColumns: '1fr' }} gap="300">
                        <GridItem>
                            <ContentCard title={<LocalizedText textKey={TextKey.DetailPlural} />}>
                                <OrderItemDetail orderItem={orderItem} />
                            </ContentCard>
                        </GridItem>
                        <GridItem>
                            <ContentCard title={<LocalizedText textKey={TextKey.ActionLog} />}>
                                <ActionLogItemList actionLogItems={actionLogItems} />
                            </ContentCard>
                        </GridItem>
                    </Grid>
                </Container>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};

export default OrderItemActionLogPage;
